import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface ISuccess {
  type: number,
  dataSource:any[]

}

@Component
export default class Success extends tsx.Component<ISuccess> {
  
  @Prop() public type?: number;
  @Prop() public dataSource?: [];
  
  mounted(): void {
    document.title = '领取福利'
  }
  
  renderTips () {
    
    if (this.$props.type === 1) {
      return (
        <div class='tips'>
          您已领取过该奖励
        </div>
      )
    }
  
    if (this.$props.type === 2) {
      return (
        <div class='success'>
          {this.$props.dataSource.map(item => <p>{item}</p>)}
        </div>
      )
    }
    
    return <div></div>
    
  }
  
  render() {
    
    if (this.$props.type === 0) return <div class='welfare'></div>
    
    return (
      <div class='welfare'>
        {this.renderTips()}
        <div class='introduced'>
          <p class='title'>使用方法：</p>
          <p class='describe'>下载“<span >爱云兔云手机</span>”app，在“<span>个人中心</span>”里面进行使用</p>
        </div>
        
        <div class='personalCenter'>
          <img src={require('@/assets/img/Welfare-3.png')} alt=""/>
        </div>
        
      </div>
    )
  }
  
}
